module.exports = __webpack_public_path__ + "static/media/document.d5920148.svg";